<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button v-if="$checkRole($accessModule.vendor_linking, 'update')" label="Save" @click="save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown 
                                            label="Supplier" 
                                            vLabel="name" 
                                            v-model="$v.vendor_linking.supplier.$model" 
                                            :options="suppliers" 
                                            :filterable="false" 
                                            @search="searchSupplier" 
                                            @change="selectSupplier" 
                                            required />
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown 
                                            label="Client Contract" 
                                            vLabel="contract_name" 
                                            v-model="$v.vendor_linking.client_contract.$model" 
                                            :options="client_contract" 
                                            :filterable="false" 
                                            @search="searchClientContract" 
                                            required />
                                    </b-col>
                                    <b-col md="2"></b-col>
                                    <b-col md="2">
                                        <gofix-form-dropdown 
                                            vLabel="reference_value_text" 
                                            class="gofixInputNoMinWidth" 
                                            label="Status" 
                                            required 
                                            :reduce="option => option.reference_value_text" 
                                            v-model="$v.vendor_linking.status.$model" 
                                            :options="vendor_linking_status" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-tree 
                                            label="Service Categories" 
                                            valueFormat="object" 
                                            :default-expand-level="1" 
                                            :options="service_category"
                                            v-model="$v.vendor_linking.service_category.$model" 
                                            :normalizer="normalizer" 
                                            :loadOptions="loadOptionsService" 
                                            @input="selectService" 
                                            search-nested 
                                            required>
                                        </gofix-form-tree>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-properties 
                                            label="Property" 
                                            valueFormat="object" 
                                            :contract-id="(vendor_linking && vendor_linking.client_contract) ? vendor_linking.client_contract.id : null" 
                                            required 
                                            v-model="$v.vendor_linking.properties.$model" 
                                            search-nested 
                                            @change="selectProperty" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown 
                                            label="Supplier Contract" 
                                            vLabel="contract_name" 
                                            :reduce="option => option['id']" 
                                            v-model="vendor_linking.supplier_contract" 
                                            :options="supplier_contract" 
                                            :filterable="false" />
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const simulateAsyncOperation = fn => {
    setTimeout(fn, 500)
}

export default {
    name: 'tax-detail',
    components: {},
    data() {
        return {
            tabData: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            }, ],
            vendor_linking: {},
            suppliers: [],
            client_contract: [],
            service_category: [],
            property: [],
            supplier_contract: [],
            loading: {
                serviceCategory: false,
                properties: false,
                supplierContract: false,
            },
            vendor_linking_status: []
        }
    },
    mixins: [validationMixin],
    validations: {
        vendor_linking: {
            supplier: {
                required
            },
            client_contract: {
                required
            },
            service_category: {
                required
            },
            properties: {
                required
            },
            status: {
                required
            }
        }
    },
    computed: {
        ...mapGetters({
            Item: 'VendorLinkingController/Item'
        })
    },
    watch: {
        "vendor_linking.client_contract": function(val) {
            if (val && val.id) {
                this.loading.serviceCategory = true
                this.loading.properties = true
                this.loading.supplierContract = true
                this.vendor_linking.client_contract_id = val.id
                new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${val.id}/tree-service-categories/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        this.service_category = response.data.data
                        this.loading.serviceCategory = false
                    })
                    .catch(error => {
                        this.loading.serviceCategory = false
                    });
                });

                new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${val.id}/tree-properties/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        this.property = response.data.data;
                        this.loading.properties = false
                    })
                    .catch(error => {
                        this.loading.properties = false
                    });
                });

                this.$store.dispatch('ContractController/getRelatedSupplier', {
                    contract_id: val.id,
                    contract_type: 's_contract'
                })
                .then(response => {
                    this.supplier_contract = response.data.data.listSuppler
                    this.loading.supplierContract = false
                })
                .catch(error => {
                    this.loading.supplierContract = false
                })
            }
        }
    },
    async created() {
        if (!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
            return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
        }

        this.getSupplier();
        this.getCContract();
        this.getVendorLinkingStatus();
        if (!this.Item || this.Item && this.Item.id != this.$route.params.id) {
            await this.$store.dispatch('VendorLinkingController/getItem', this.$route.params.id);
        }

        this.vendor_linking = await JSON.parse(JSON.stringify(this.Item));
    },
    methods: {
        save() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.$v.vendor_linking.$touch()
                if (!this.$v.vendor_linking.$error) {
                    let request = {
                        id: this.vendor_linking.id,
                        supplier_id: this.vendor_linking.supplier_id,
                        client_contract_id: this.vendor_linking.client_contract_id,
                        supplier_contract_id: this.vendor_linking.supplier_contract_id,
                        service_category_id: this.vendor_linking.service_category_id,
                        property_id: this.vendor_linking.property_id,
                        location_root_path: this.vendor_linking.location_root_path,
                        location_building_path: this.vendor_linking.location_building_path,
                        status: this.vendor_linking.status,
                        supplier_name: this.vendor_linking.supplier_name,
                        service_category_name: this.vendor_linking.service_category_name
                    }
                    this.$store.dispatch("VendorLinkingController/updateItem", request).then(async result => {
                        await this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
                        await this.$alertNotification(this.$notificationV2('editing', 'vendor_linking'));
                    });
                } else {
                    if (!this.vendor_linking.supplier_id) {
                        return this.$alertNotification("Supplier is a required field.", "danger");
                    }

                    if (!this.vendor_linking.client_contract_id) {
                        return this.$alertNotification("Client Contarct is a required field.", "danger");
                    }

                    if (!this.vendor_linking.service_category_id) {
                        return this.$alertNotification("Service Categories is a required field.", "danger");
                    }

                    if (!this.vendor_linking.property_id) {
                        return this.$alertNotification("Property is a required field.", "danger");
                    }

                    if (!this.vendor_linking.status) {
                        return this.$alertNotification("Status is a required field.", "danger");
                    }
                }
            }, 300);
        },
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.data.name,
                    children: node.children
                }
            return {
                id: node.data.id,
                label: node.data.name,
                children: undefined
            }
        },
        selectSupplier(value) {
            this.vendor_linking.supplier_id   = value ? value.id : null;
            this.vendor_linking.supplier_name = value ? value.name : null;
        },
        selectProperty(value) {
            this.vendor_linking.property_id            = value ? value.id : null;
            this.vendor_linking.location_root_path     = value ? value.root_path : null;
            this.vendor_linking.location_building_path = value ? value.building_path : null;
        },
        selectService(value) {
            this.vendor_linking.service_category_id   = value ? value.id : null;
            this.vendor_linking.service_category_name = value ? value.name : null;
        },
        loadOptionsService({
            action,
            parentNode,
            callback
        }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return
                };
                if (parentNode.data.isBatch) {
                    global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/${parentNode.data.id}`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data
                                callback();
                            })
                        })
                } else {
                    parentNode.children = []
                    callback();
                }
            }
        },
        searchSupplier(search, loading) {
            this.suppliers = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplier({ name: search }, 100);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async getSupplier(filter = {}, limit = 100) {
            filter['is_supplier'] = true
            await this.$store.dispatch('OrganizationController/searchItemsInUser', { filter: filter, limit: limit })
                .then(response => {
                    this.suppliers = response.data.data.items
                })
        },
        searchClientContract(search, loading) {
            this.suppliers = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getCContract(1, { name: search }, 100);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async getCContract(page = 1, filter = null, limit = 100) {
            await this.$store.dispatch('ContractController/getListClientContractsSearchAll', [page, filter, limit])
                .then(response => {
                    this.client_contract = response.data.data.contracts
                })
        },
        getVendorLinkingStatus() {
            let filter = { reference_type: "Vendor linking status" };
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.vendor_linking_status = response.items;
                })
        }
    }
}
</script>